import React, { Component } from 'react';
import {
    Modal,
    Button,
    Form,
    Row,
    Col,
    Select,
    DatePicker,
    Input
} from 'antd';
import _ from 'lodash';
import client from '../api/client';
import moment from 'moment';

const Option = Select.Option;

const _createUIOptions = codes => {
    return codes.map(c => (
        <Option key={c || 'default'} value={c}>
            {c}
        </Option>
    ));
};

class CostInfoDialog extends Component {

    constructor(props) {
        super(props);
        this.state = {
            data: this.props.data || { type: 'Personal' },
            departmentOptions: ['Front Office','Middle Office', 'Back Office'],
            department2Options: ['Compliance', 'Marketing', 'Non-PM', 'PM'],
            locationOptions: ['HongKong', 'India', 'Japan', 'Shanghai', 'Singapore', 'Taipei'],
            ccyMap: {
                'HongKong': 'HKD', 'India': 'INR', 'Japan': 'JPY', 'Shanghai': 'CNY', 'Singapore': 'SGD', 'Taipei': 'TWD'
            },
            roleOptions: ['Non-PM', 'PM'],
        }
    }

    _closeModal = () => {
        this.props.closeDialog();
    };

    _saveData = () => {
        const { data } = this.state;
        client.saveCostInfo(data).then(resp => {
            this.props.loadData()
            this._closeModal();
        }).catch(err => console.log(err))
    }

    _onInputChange = ({ name, value }) => {
        const { data, ccyMap } = this.state;
        let updateData = {
            ...data,
            [name]: value
        };
        if(name === 'location') {
            updateData = {
                ...updateData,
                ccy: ccyMap[value]
            }
        }
        this.setState({
            data: updateData
        });
    };

    _createForm = () => {
        const { data } = this.state;
        return (
            <Row>
                <Col span={24}>
                    <Form.Item
                        label={'Department'}
                    >
                        <Select
                            value={data.department}
                            onChange={value => {
                                this._onInputChange({ name: 'department', value });
                            }}
                        >
                            {_createUIOptions(this.state.departmentOptions)}
                        </Select>
                    </Form.Item>
                    <Form.Item
                        label={'Department2'}
                    >
                        <Select
                            value={data.department2}
                            onChange={value => {
                                this._onInputChange({ name: 'department2', value });
                            }}
                        >
                            {_createUIOptions(this.state.department2Options)}
                        </Select>
                    </Form.Item>
                    <Form.Item
                        label={'Location'}
                    >
                        <Select
                            value={data.location}
                            onChange={value => {
                                this._onInputChange({ name: 'location', value });
                            }}
                        >
                            {_createUIOptions(this.state.locationOptions)}
                        </Select>
                    </Form.Item>
                     <Form.Item
                        label={'Role'}
                    >
                        <Select
                            value={data.role}
                            onChange={value => {
                                this._onInputChange({ name: 'role', value });
                            }}
                        >
                            {_createUIOptions(this.state.roleOptions)}
                        </Select>
                    </Form.Item>
                    <Form.Item
                        label={'FlexCodeAna1'}
                    >
                        <Input
                            value={data.flexCodeAna1}
                            onChange={e => {
                                this._onInputChange({ name: 'flexCodeAna1', value: e.target.value });
                            }}
                        />
                    </Form.Item>
                    <Form.Item
                        label={'Effective From'}
                    >
                        <DatePicker
                          placeholder={'effective from'}
                          allowClear={'false'}
                          value={moment(data.effectiveFrom, 'YYYY-MM-DD')}
                          size='middle'
                          onChange={(date, datestr) => {
                             this._onInputChange({ name: 'effectiveFrom', value: datestr });
                          }}
                        />
                    </Form.Item>
                    <Form.Item
                        label={'Effective To'}
                    >
                        <DatePicker
                          placeholder={'effective to'}
                          allowClear={'false'}
                          value={moment(data.effectiveTo, 'YYYY-MM-DD')}
                          size='middle'
                          onChange={(date, datestr) => {
                             this._onInputChange({ name: 'effectiveTo', value: datestr });
                          }}
                        />
                    </Form.Item>
                    
                </Col>
            </Row>
        )
    }

    render() {
        return (
            <Modal
                size="large"
                visible={true}
                title={`Cost Info`}
                width={500}
                style={{ height: 600 }}
                footer={[
                    <div style={{ textAlign: 'right' }}>
                        <Button
                            size="small"
                            type="primary"
                            onClick={() => {
                                this._saveData();
                            }}
                        >
                            Submit
                        </Button>
                        <Button
                            size="small"
                            type="primary"
                            onClick={() => {
                                this._closeModal();
                            }}
                        >
                            Cancel
                        </Button>
                    </div>
                ]}
                closable={false}
            >
                <div style={{ height: '400px', overflow: 'auto' }}>
                    {this._createForm()}
                </div>
            </Modal>
        );
    }
}

export default CostInfoDialog;
